import LabelPresenter from '../../helpers/LabelPresenter'

export default {
    SET_CHANNEL (state, channel) {
        state.channel = channel
    },

    SET_COLUMNS (state, columns) {
        state.columns = columns
    },

    SET_JOBS (state, jobs) {
        state.jobs.collect(jobs)
    },

    // Job
    SET_JOB (state, updatedJob) {
        let job = state.jobs.find(updatedJob.id)

        job.update(updatedJob)
    },

    ADD_JOB (state, job) {
        state.jobs.add(job)
    },

    REMOVE_JOB (state, jobId) {
        state.jobs.remove(jobId)
    },

    SET_JOB_ACTIVITY (state, activity) {
        let job = state.jobs.find(activity.job_id)

        if (job) {
            job.update({ last_activity: activity })
        }
    },

    // Job Members
    SET_JOB_MEMBERS (state, data) {
        let job = state.jobs.find(data.job.id)

        job.members = data.members
    },

    ADD_JOB_MEMBER (state, member) {
        let job = state.jobs.find(member.job_id)

        job.addMember(member)
    },

    REMOVE_JOB_MEMBER (state, data) {
        let job = state.jobs.find(data.job_id)

        job.removeMember(data.member_id)
    },

    // Column
    ADD_COLUMN (state, column) {
        state.columns.push(column)
    },

    SET_COLUMN (state, updatedColumn) {
        let column = state.columns.find(column => column.id === updatedColumn.id)

        column.name = updatedColumn.name
    },

    REPOSITION_COLUMN (state, { id, position }) {
        let column = state.columns.find(column => column.id === id)

        column.position = position
    },

    REMOVE_COLUMN_JOBS (state, columnId) {
        state.jobs = state.jobs.where('column_id', '!==', columnId)
    },

    REMOVE_COLUMN (state, columnId) {
        state.columns = state.columns.filter(column => column.id !== columnId)
    },

    // Channel Members
    SET_MEMBERS (state, users) {
        state.members = users
    },

    ADD_MEMBER (state, user) {
        state.members.push(user)
    },

    REMOVE_MEMBER (state, userId) {
        state.members = state.members.filter(member => member.id !== userId)
    },

    SET_MEMBER (state, updatedMember) {
        const index = state.members.findIndex(member => member.id === updatedMember.id)

        state.members.splice(index, 1, updatedMember)
    },

    // Archive
    SET_ARCHIVE (state, data) {
        state.archive.addItems(data)
    },

    ADD_ARCHIVED_JOB (state, job) {
        state.archive.items.unshift(job)
    },

    REMOVE_ARCHIVED_JOB (state, jobId) {
        state.archive.items = state.archive.items.filter((job) => job.id !== jobId)
    },

    // Current Channel Member
    SET_CURRENT_CHANNEL_MEMBER (state, channelMember) {
        state.currentChannelMember = channelMember
    },

    // Labels
    SET_LABELS (state, labels) {
        state.labels = LabelPresenter.present(labels)
    },

    ADD_LABEL (state, label) {
        state.labels.push(label)
        state.labels = LabelPresenter.present(state.labels)
    },

    SET_LABEL (state, updatedLabel) {
        const index = state.labels.findIndex(label => label.id === updatedLabel.id)

        state.labels.splice(index, 1, updatedLabel)

        state.labels = LabelPresenter.present(state.labels)

        state.jobs.items.forEach((job) => {
            job.updateLabel(updatedLabel)
        })
    },

    REMOVE_LABEL (state, labelId) {
        state.labels = state.labels.filter((label) => label.id !== labelId)

        state.jobs.items.forEach((job) => {
            job.removeLabel(labelId)
        })
    },

    ADD_JOB_LABEL (state, data) {
        let job = state.jobs.find(data.job_id)

        job.addLabel(data.label)
    },

    REMOVE_JOB_LABEL (state, data) {
        let job = state.jobs.find(data.job_id)

        job.removeLabel(data.label_id)
    },

    SET_ORIGINAL_JOBS (state, jobs) {
        state.originalJobs = jobs
    },

    SET_FILTERS (state, filters) {
        state.filters = filters
    },

    CLEAR_FILTERS (state) {
        Object.keys(state.filters).forEach((filter) => {
            state.filters[filter] = []
        })
    }
}
